import { setOtpVerifiedEmailAction } from 'common/commonRedux/auth/actions';
import { useIsDark } from 'common/hooks';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import topImg from '../authTop.png';
import OtpSend from '../otpVerificaton/OtpSend';
import background from "./signup_bg.png";
import SignupForm from './SignupForm';
import SubscriptionPlan from './SubscriptionPlan';


const SignUpComponent = () => {
  const isDark = useIsDark();
  const { auth } = useSelector((state: any) => state, shallowEqual);
  const email = useSelector(
    (state: any) => state.auth?.profileData?.otpVerifiedEmail
  );
  const navigate = useNavigate();
  const dispatch: any = useDispatch()
  useEffect(() => {
    if (auth.isAuth) {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  useEffect(() => {
    dispatch(setOtpVerifiedEmailAction(''))
  }, [dispatch])

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 w-full  min-h-screen ">

      <div className={`w-full h-full flex justify-center items-center px-4 md:px-12 py-12 ${isDark ? 'bg-[#0B172B]' : 'bg-[#DEEDFF]'}`}>
        <img src={topImg} alt="" className='absolute top-0 left-0 hidden md:block' />
        {email ? <SignupForm /> : <OtpSend />}
      </div>

      <div className='col-span-2 h-full py-12 relative bg-[#0f172a]'>
        <div className="absolute inset-0 z-0 opacity-50">
          <img src={background} alt="" className="w-full h-full object-cover" />
        </div>

        <SubscriptionPlan />
      </div>
    </div>
  );
}

export default SignUpComponent